import sensoryTemplateList from "@/components/page/sensory/sensory-template/sensoryTemplateList";
import addTemplate from "@/components/page/sensory/sensory-template/addTemplate";
import sensoryReportList from "@/components/page/sensory/sensory-report/sensoryReportList";
import sensoryCalibrationList from "@/components/page/sensory/sensory-calibration/sensoryCalibrationList";
import sensoryReportDetail from "@/components/page/sensory/sensory-report/sensoryReportDetail";
import sensoryCalibrationDetail from "@/components/page/sensory/sensory-calibration/sensoryCalibrationDetail";

export default [
    {
        path:'/sensoryTemplate',
        name:'sensoryTemplate',
        component:sensoryTemplateList,
        meta: { title:'sensory.template.title' },
    },
    {
        path:'/sensoryTemplate-add',
        component:addTemplate,
        name:'addTemplate',
        meta: { title:'sensory.template.addTemplate' },
    },
    {
        name: "sensoryReportList",
        path:'/sensoryReport',
        meta: { title: 'sensory.report.title' },
        component:sensoryReportList
    },
    {
        name: "newSensoryReport",
        path:'/sensoryReport-add',
        meta: { title: 'common.edit' },
        component:sensoryReportDetail
    },
    {
        name: "sensoryReportDetail",
        path:'/sensoryReport-edit/:reportId',
        component: sensoryReportDetail,
        meta: { title: 'common.edit' },
    },
    {
        path:'/sensoryCalibration',
        name:'sensoryCalibration',
        component: sensoryCalibrationList,
        meta: { title: 'sensory.calibration.title' },
    },
    {
        name: "newSensoryCalibration",
        path:'/sensoryCalibration-add',
        component: sensoryCalibrationDetail,
        meta: { title: 'common.edit' },
    },
    {
        name: "sensoryCalibrationDetail",
        path:'/sensoryCalibration-edit/:id',
        component: sensoryCalibrationDetail,
        meta: { title: 'common.edit' },
    },
]
